import { Model_Update, Model_Init_Z52A72C54 } from "./Types.fs.js";
import { view } from "./View.fs.js";
import { PageHeader } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { singleton, tail, head, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { DashboardPage } from "../DashBoardPage.fs.js";
import { WebPart$3 } from "../../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3((_arg, session, _arg_1) => Model_Init_Z52A72C54(session), Model_Update, view, (_arg_3) => (new PageHeader(0, [])), (_arg_5) => (!isEmpty(_arg_5) ? ((head(_arg_5) === "dashboard") ? (isEmpty(tail(_arg_5)) ? (new DashboardPage()) : undefined) : undefined) : undefined), (_arg_4) => singleton("dashboard"), (_arg_2) => {
    if (_arg_2.tag === 1) {
        return _arg_2.fields[0];
    }
    else {
        return undefined;
    }
});

//# sourceMappingURL=Webpart.fs.js.map
